import {securedFetch} from "../auth/authService";
import {SYSTEM_API, REPORT_API, SYSTEM_Mail_API} from "../vars";
import store from "../app/store";
import {createAction} from "@reduxjs/toolkit";
import {ACTION_SYSTEM_DATA_LOADED} from "./SystemPageReducer";
import * as moment from "moment";
import {showDangerToast, showSuccessToast} from "../validation/ToastContainer";

export const getCpuLoad = async () => {
    const response = await securedFetch(`${SYSTEM_API}/cpu`);
    if (response.ok) {
        return await response.json();
    } else {
        return {
            currentLoad: 0,
            currentLoadUser: 0,
            currentLoadSystem: 0,
            manufacturer: 'Unknown CPU',
            brand: '',
            speed: ''
        }
    }
}

export const getMemLoad = async () => {
    const response = await securedFetch(`${SYSTEM_API}/mem`);
    if (response.ok) {
        return await response.json();
    } else {
        return {
            total: 'Unknown',
            free: 'Unknown',
            used: 'Unknown',
            buffers: 'Unknown',
            cached: 'Unknown'
        }
    }
}

export const getDiskUsageData = async () => {
    const response = await securedFetch(`${SYSTEM_API}/disk`);
    if (response.ok) {
        // return await response.json();
        return response.json();
    } else {
        return {
            size: 0,
            used: 0,
            available: 0,
            rxSec: 0,
            wxSec: 0
        }
    }
}

export const getSystemLoad = async () => {
    const start = moment();
    const response = await securedFetch(SYSTEM_API);
    const end = moment();
    const reqTime = Number(moment.duration(end.diff(start)).asMilliseconds() * 0.001).toFixed(2);
    const data = await response.json();
    if (response.ok) {
        data.avgResponse = reqTime;
        store.dispatch(createAction(ACTION_SYSTEM_DATA_LOADED)(data));
    } else {
        console.err("Get system load error:" + JSON.stringify(data))
    }
}

export const restartApplication = async () => {
    return await securedFetch(`${SYSTEM_API}/restart-application`, null, 'POST'
        ).then(async response => {
            if (!response.ok) {
                const json = await response.json();
                showDangerToast(`${json.message || 'Restart Application was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
            } else {
                showSuccessToast('Restart Application is successful', 'Restart Application')
            }            
            return response.ok;
        })  
}

export const rebootSystem = async () => {
    return await securedFetch(`${SYSTEM_API}/reboot-system`, null, 'POST'
        ).then(async response => {
            if (!response.ok) {
                const json = await response.json();
                showDangerToast(`${json.message || 'Reboot System was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
            } else {
                showSuccessToast('Reboot System is successful', 'Reboot System')
            }            
            return response.ok;
        }) 
}

export const resetFactory = async () => {
    return await securedFetch(`${SYSTEM_API}/reset-factory`, null, 'POST'
        ).then(async response => {
            if (!response.ok) {
                const json = await response.json();
                showDangerToast(`${json.message || 'Reset Factory was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
            } else {                
                await securedFetch(`${REPORT_API}/reset-factory`, null, 'POST'
                ).then(async response => {
                    if (!response.ok) {
                        const json = await response.json();
                        showDangerToast(`${json.message || 'Reset Factory was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!');
                    } else {
                        await securedFetch(`${SYSTEM_Mail_API}/reset-factory`, null, 'POST'
                        ).then(async response => {
                            if (!response.ok) {
                                const json = await response.json();
                                showDangerToast(`${json.message || 'Reset Factory was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!');
                            } else {  
                                await securedFetch(`${SYSTEM_API}/restart-application`, null, 'POST'
                                ).then(async response => {
                                    if (!response.ok) {
                                        const json = await response.json();
                                        showDangerToast(`${json.message || 'Restart Application was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
                                    }                                         
                                    showSuccessToast('Reset Factory is Done!', 'Reset Factory')
                                })
                            }                       
                        })
                    }
                })
            }            
            return response.ok;
        }) 
}



